import React, { Fragment } from "react";
import SearchPackages from "./components/SearchPackages";
import PostApiDisagreement from "./api/PostApiDisagreement";
import DocList from "./components/DocList";
import GetExistDoc from "./functions/GetExistDoc";
import WebScam from "./components/webScan";
import GetApiData from "./functions/GetApiData";
import O2FSModal from "./components/O2FSModal";
import CardsOptions from "./components/cards.json";
import UnpackingForm from "./components/unpacking";
import Disagreement from "./components/Disagreement";
import fGetExistDocO2FS from "./functions/GetExistDocO2FS";

class Unpacking extends React.Component {
  timer = null;

  state = {
    disagreement: { open: false, alert: null, loading: false },
    setHeader: false,
    shipments: {
      data: null,
      state: false,
      alerts: [],
    },
    apidata: [],
    scanWebOpen: false,
    scanFile: [],
    docDetailForm: {
      open: false,
      data: null,
      idx: -1,
    },
    o2FSForm: {
      open: false,
      value: "",
      loading: false
    },
    cardLoading: false,
    cardData: [],
    cardSelected: null,
    card: {
      CurrCode: null,
      CardCodes: null,
      CardCode: null,
      CardName: null,
      CardICO: null,
      CardDIC: null,
      CntctCode: null,
      CntctName: null,
      CntctTel1: null,
      CntctCellolar: null,
      CntctEmail: null,
      PaySameShip: false,
      PayToCode: null,
      PayToStreet: null,
      PayToCity: null,
      PayToZipCode: null,
      PayToCountry: null,
      PayToWorplace: null,
      ShipToCode: null,
      ShipToStreet: null,
      ShipToCity: null,
      ShipToZipCode: null,
      ShipToCountry: null,
      ShipToAddrOnLine: null,
      ShipToWorkplace: null,
      CommChannel: null,
      RetTranspCode: null,
    },
    docs: [],
  };

  ApiDataFormShipments = async (e) => {
    this.setState({
      shipments: {
        ...this.state.shipments,
        alerts: [
          { variant: this.props.VARIANT.INFO, text: "Hledám api data..." },
        ],
      },
    });
    var _res = await GetApiData({ ...this.props, ship: e?.PackCode });
    if (_res[0].api_name  === "TMBHIRR") {
      this.setState({
        apidata: _res,
        card: {CardCode: "Z0180", CardName: "T-Mobile Czech Republic a.s.", CardICO: "64949681", CardDIC: "CZ64949681", PayToCountry: "CZ"} ,
        cardData: {CardCode: "Z0180", CardName: "T-Mobile Czech Republic a.s.", CardICO: "64949681", CardDIC: "CZ64949681" , PayToCountry: "CZ"},
        cardSelected: {CardCode: "Z0180", CardName: "T-Mobile Czech Republic a.s.", CardICO: "64949681", CardDIC: "CZ64949681" , PayToCountry: "CZ"},
        shipments: { ...this.state.shipments, alerts: [] },
      });
    } else if (_res[0].api_name  === "O2CZ") {
      this.setState({
        apidata: _res,
        card: {CardCode: "Z0174", CardName: "O2 Czech Republic a.s.", CardICO: "60193336", CardDIC: "CZ60193336", PayToCountry: "CZ"} ,
        cardData: {CardCode: "Z0174", CardName: "O2 Czech Republic a.s.", CardICO: "60193336", CardDIC: "CZ60193336" , PayToCountry: "CZ"},
        cardSelected: {CardCode: "Z0174", CardName: "O2 Czech Republic a.s.", CardICO: "60193336", CardDIC: "CZ60193336" , PayToCountry: "CZ"},
        shipments: { ...this.state.shipments, alerts: [] },
      });
    } else {
      this.setState({
        apidata: _res,
        shipments: { ...this.state.shipments, alerts: [] },
      });
    }
    
  };


  searchO2FS = async () => {
    this.setState({o2FSForm: {...this.o2FSForm, loading: true}})
    let _data = await fGetExistDocO2FS({ ...this.props, anyString: this.state.o2FSForm.value, idPack: this.state.shipments.data?.Id });
    this.setState({o2FSForm: {...this.o2FSForm, loading: false}})
    if (_data.length > 0) {
      this.setState({
        card: _data[0],
        docs: _data,
        cardData: [{ ..._data[0] }],
        cardSelected: [{ ..._data[0] }],
      });
    }
  }

  GetExistDocsInShipments = async (e) => {
    let _data = await GetExistDoc({ ...this.props, idPack: e?.Id });
    if (_data.length > 0) {
      this.setState({
        card: _data[0],
        docs: _data,
        cardData: [{ ..._data[0] }],
        cardSelected: [{ ..._data[0] }],
      });
    }
  };

  ShipmentsChangeHandler = (e) => {
    this.ApiDataFormShipments(e);
    this.GetExistDocsInShipments(e);
    this.setState({
      shipments: { ...this.state.shipments, data: e, state: true },
      scanWebOpen: e?.PackCode ? true : false,
    });
  };
  componentDidMount() {
    const { Icon, Bs, SIZE, VARIANT } = this.props;
    this.props.setHeaderPage({
      Icon: <Icon gopackage className="c-placeholder c-green" />,
      Title: "Rozbalení zásilek",
      SubTitle: "Začni tím, vyplníš pole 'Číslo zásilky'",
      Buttons: (
        <>
          <Bs
            button
            className="me-4"
            size={SIZE.SM}
            disabled={this.state.scanWebOpen}
            variant={VARIANT.SUCCESS}
            onClick={() => window.location.reload()}
          >
            Nový balík
          </Bs>
          <Bs
            button
            size={SIZE.SM}
            disabled={this.state.scanWebOpen}
            variant={VARIANT.SUCCESS}
            onClick={() => this.setState({ scanWebOpen: true })}
          >
            Skenování
          </Bs>
        </>
      ),
    });

    /* Defaultní nastavení scanu pro předpříjem (Rozbaleno) */
    localStorage.setItem(
      "webCam",
      JSON.stringify({ height: 1536, width: 2048 })
    );
  }

  sentDisagreement = async (e) => {
    this.setState({
      disagreement: { open: false, alert: null, loading: false },
    });
    var _res = await PostApiDisagreement({
      ...this.props,
      data: { ...this.state, text: e, rfid: sessionStorage.getItem("RFID") },
    });

    if (_res.status === 200) this.props.setToast(
      "Email byl úspěšně odeslán.",
      "Neshoda",
      "success"
    );
    if (_res.status !== 200) this.props.setToast(
      "Chyba při odeslání emailu: " + _res.data,
      "Neshoda",
      "error"
    );
  };

  selectedCard = () => {
    if (this.state.card.CardCode !== null) {
      if (CardsOptions.filter(f => f.CardCode === this.state.card.CardCode).length > 0) {
        return CardsOptions.filter(f => f.CardCode === this.state.card.CardCode)[0]
      } else {
        return CardsOptions.filter(f => f.CardCode === "X9999")[0]
      }
    } else return null;
    
  }

  setDoc = (e) => {
    this.GetExistDocsInShipments(this.state.shipments.data);
    this.setState({ docDetailForm: { open: false, data: null, idx: -1 } });
  };

  setapidata = (e) => {};

  render() {
    const { prepare, Icon, Bs, SIZE, VARIANT } = this.props;
    if (!this.state.setHeader) {
      this.setState({ setHeader: true });
      this.props.setHeaderPage({
        Icon: <Icon gopackage className="c-placeholder c-green" />,
        Title: "Rozbalení zásilek",
        SubTitle: "Začni tím, vyplníš pole 'Číslo zásilky'",
        Buttons: (
          <>
            <Bs
              button
              className="me-4"
              size={SIZE.SM}
              disabled={this.state.scanWebOpen}
              variant={VARIANT.SUCCESS}
              onClick={() => window.location.reload()}
            >
              Nový balík
            </Bs>
            <Bs
              button
              size={SIZE.SM}
              disabled={this.state.scanWebOpen}
              variant={VARIANT.SUCCESS}
              onClick={() => this.setState({ scanWebOpen: true })}
            >
              Skenování
            </Bs>
          </>
        ),
      });
    }
    return (
      <>
        {this.state.disagreement.open && (
          <Disagreement
            {...this.props}
            alert={this.state.disagreement.alert}
            loading={this.state.disagreement.loading}
            sent={this.sentDisagreement}
            hideDisagreement={() =>
              this.setState({
                disagreement: { open: false, alert: null, loading: false },
              })
            }
          />
        )}
        {this.state.o2FSForm.open && (
          <O2FSModal {...this.props} set={(e) => this.setState(e)} sent={this.searchO2FS} state={this.state.o2FSForm} open={this.state.o2FSForm.open} value={this.state.o2FSForm.value}/>
        )}
        {this.state.docDetailForm.open && (
          <UnpackingForm
            {...this.props}
            close={() =>
              this.setState({
                docDetailForm: { open: false, data: null, idx: -1 },
              })
            }
            apidata={this.state.apidata}
            docData={this.state.docDetailForm}
            card={this.state.card}
            shipDoc={this.state.shipments.data}
            addDocScan={this.state.scanFile}
            brtxcard={this.state.brtxcard}
            apiset={this.setapidata}
            setDoc={this.setDoc}
          />
        )}
        {this.state.scanWebOpen && (
          <WebScam
            {...this.props}
            hideWebScan={(e) => this.setState({ scanWebOpen: false })}
            files={this.state.scanFile}
            webCam
            twain
            mobile
            hdr={false}
            setFiles={(e) => this.setState({ scanFile: e })}
          />
        )}
        <SearchPackages
          {...this.props}
          prepare={prepare}
          hideShip={this.state.shipments.state}
          shipments={this.state.shipments.data}
          alerts={this.state.shipments.alerts}
          setDisagreement={() =>
            this.setState({
              disagreement: { open: true, alert: null, loading: false },
            })
          }
          setEmpty={this.Empty}
          reset={() =>
            this.setState({
              shipments: { data: null, state: false, alerts: [] },
            })
          }
          hide={() =>
            this.setState({
              shipments: {
                ...this.state.shipments,
                state: !this.state.shipments.state,
              },
            })
          }
          set={this.ShipmentsChangeHandler}
        />

        {this.state.shipments.data && (
          <Bs row className="mt-4">
            <Bs col xs={12}>
              <Bs formtext><Bs strong>Zákazník</Bs></Bs>
              <Bs brtxselect options={CardsOptions} placeholder="vyber zákazníka" value={this.selectedCard(this.state.card.CardCode)} onChange={(e) => {
                this.setState({
                card: e,
                cardData: e,
                cardSelected: e,
              })
              }}/>
            </Bs>
          </Bs>
          
          
        )}
        {this.state.cardSelected && (
          <DocList
            {...this.props}
            o2FSForm={this.state.o2FSForm}
            set={(e) => this.setState(e)}
            docs={this.state.docs}
          />
        )}
      </>
    );
  }
}

export default Unpacking;
